import type { BoundingBoxProps } from "./bounding-box.type";

import { Typography } from "antd";

import { getBoundingBoxStyle } from "./bounding-box.helper";

import "./bounding-box.style.less";

const { Text } = Typography;

export const BoundingBox = ({ box, hideLabel }: BoundingBoxProps) => {
  const boundingBoxStyle = getBoundingBoxStyle(box);
  const showLabel = box.label && !hideLabel ? true : false;

  return (
    <div className="bounding-box" style={boundingBoxStyle}>
      {showLabel && (
        <Text ellipsis title={box.label} className="bounding-box-text">
          {box.label}
        </Text>
      )}
    </div>
  );
};
